/* eslint-disable */
import {
  AppBarProps,
  Button,
  AppBar,
  Box,
  Hidden,
  IconButton,
  Toolbar,
} from '@material-ui/core';
import { experimentalStyled } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
// import icons
import CogIcon from '../../icons/Cog';
import MenuIcon from '../../icons/Menu';
import LogoFull from '../Logo-Full';
// import componenets
import AccountPopover from './AccountPopover';
// import ContentSearch from './ContentSearch';
import Notification from './NotificationsPopover';
// import LanguagePopover from './LanguagePopover';
import Imagen from '../../assets/img/just-logo.svg';

interface DashboardNavbarProps extends AppBarProps {
  onSidebarMobileOpen?: () => void;
}

const DashboardNavbarRoot = experimentalStyled(AppBar)(({ theme }) => ({
  ...(theme.palette.mode === 'light' && {
    backgroundColor: theme.palette.primary.contrastText,
    boxShadow: 'none',
    color: theme.palette.text.secondary,
  }),
  ...(theme.palette.mode === 'dark' && {
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none',
  }),
  zIndex: theme.zIndex.drawer + 100,
}));

const DashboardNavbar: FC<DashboardNavbarProps> = (props) => {
  const { onSidebarMobileOpen, ...other } = props;
  const { user } = useAuth();

  const url = 'https://staging.releasefintech.com/dashboard';
  // const url='https://app.releasefintech.com/dashboard';

  return (
    <DashboardNavbarRoot {...other}>
      <Toolbar sx={{ minHeight: 64 }}>
        {/* <Hidden lgUp> */}
        <IconButton color="inherit" onClick={onSidebarMobileOpen}>
          <MenuIcon fontSize="small" />
        </IconButton>
        {/* </Hidden> */}
        {/* <Hidden lgDown> */}
        <RouterLink
          //  onClick={() => window.location.replace(url)}
          to={'/dashboard'}
        >
          {/* <LogoFull
            sx={{
              height: 50,
              width: 100,
            }}
          /> */}
          <img
            src={Imagen}
            style={{ height: 55, width: 190 }}
            alt="website logo"
          />
        </RouterLink>
        {/* </Hidden> */}
        <Box
          sx={{
            flexGrow: 1,
            ml: 2,
          }}
        />
        {/* <LanguagePopover /> */}
        <Box sx={{ ml: 1 }}>
          {user.isAdminUser !== true && user.rolDesc === 'master' && (
            <>
              {user.firstStepContract !== null &&
                user.firstStepContract !== undefined && (
                  <>
                    {user.businessId.firstStep === true ||
                      /* prettier-ignore */
                      user.businessId.firstStep === null && (
                  <Button
                    sx={{
                      backgroundColor: '#034787',
                      borderRadius: '64px',
                    }}
                    onClick={() => {
                      if (
                        user.firstStepContract.email === null &&
                        user.firstStepContract.notes === '' &&
                        user.signedContratUrl === 'N/A'
                      ) {
                        window.localStorage.setItem('firstStep', '2');
                        window.location.reload();
                      }
                      if (
                        user.firstStepContract.email === null &&
                        user.firstStepContract.notes === '' &&
                        user.signedContratUrl !== 'N/A'
                      ) {
                        window.localStorage.setItem('firstStep', '2');
                        window.location.reload();
                      }
                      if (
                        user.firstStepContract.email !== null &&
                        user.firstStepContract.notes !== '' &&
                        user.signedContratUrl !== 'N/A'
                      ) {
                        window.localStorage.setItem('firstStep', '3');
                        window.location.reload();
                      }
                      if (
                        user.firstStepContract.email !== null &&
                        user.firstStepContract.notes === '' &&
                        user.signedContratUrl !== 'N/A'
                      ) {
                        window.localStorage.setItem('firstStep', '3');
                        window.location.reload();
                      }
                    }}
                    variant="contained"
                  >
                    COMPLETAR PASOS
                  </Button>
            )}
                  </>
                )}
            </>
          )}
        </Box>
        <Box sx={{ ml: 2 }}>
          <Notification />
        </Box>
        <Box sx={{ ml: 3 }}>
          <IconButton
            component={RouterLink}
            color="primary"
            to="/dashboard/account"
          >
            <CogIcon fontSize="small" />
          </IconButton>
        </Box>
        <Box sx={{ ml: 4 }}>
          <AccountPopover />
        </Box>
      </Toolbar>
    </DashboardNavbarRoot>
  );
};

DashboardNavbar.propTypes = {
  onSidebarMobileOpen: PropTypes.func,
};

export default DashboardNavbar;
